import React from "react"
import { getClasses } from "../../js/classUtils";
import "./Circle.css"

function Circle({children, onClick, active}){  

    var circleClass = getClasses({
        'circle': true,
        'circle--int': !!onClick,
        'circle--active': active
    });
      

    return(
        <div className={circleClass} onClick={onClick}>
            <div className="circle__content">
                {children}
            </div>
        </div>
    )
}

export default Circle;